import { MassTortFileGenerationView } from "@/components/features/mass-torts/MassTortFileGenerationView";
import { Card, CardContent, Typography } from "@/components/ui";
import LawWorksLoader from "@/components/ui/LawWorksLoader/LawWorksLoader";
import {
  retrieveMassTortQueryOptions,
  retrieveMassTortTemplateGenerationRequestsQueryOptions,
} from "@/lib/data/react-query/mass-torts/mass-tort";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_auth/mass-torts/$massTortSearchId/_layout/file-generation",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { massTortSearchId: massTortId } = Route.useParams();

  const { data: massTortResponse, isLoading: isMassTortLoading } = useQuery({
    ...retrieveMassTortQueryOptions(massTortId),
  });
  const {
    data: generationRequestsResponse,
    isLoading: isGenerationRequestsLoading,
  } = useQuery({
    ...retrieveMassTortTemplateGenerationRequestsQueryOptions({
      massTortId,
    }),
  });

  const massTort = massTortResponse?.data;
  const isPageLoading = Boolean(
    massTortId && (isMassTortLoading || isGenerationRequestsLoading),
  );

  if (isPageLoading) {
    return <LawWorksLoader className="w-full" />;
  }

  if (!massTortId || !massTort) {
    return (
      <div className="grid h-screen w-full grid-cols-1 gap-4 p-6">
        <Card className="flex h-full flex-col">
          <CardContent className="flex h-full flex-col items-center justify-center gap-2 text-center">
            <Typography variant="subHeading">
              Mass tort file generation
            </Typography>
            <Typography className="text-muted-foreground">
              Unable to load file generation for this mass tort.
            </Typography>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <MassTortFileGenerationView
      massTortId={massTortId}
      massTort={massTort}
      massTortCustomFields={massTort.customFields}
      generationRequests={generationRequestsResponse?.data ?? []}
    />
  );
}
